import { File } from 'order_ts/v1/order/file_pb';
import fileConstructor from '../fileConstructor';

const fileListConstructor = (
  files: Array<Partial<File.AsObject>>
): Array<File> => files.map((file) => fileConstructor(file));

export default fileListConstructor;
